import { useMemo, useEffect, useCallback, useRef, useState } from 'react';
import moment from 'moment';
import { useCalendarContext } from '../contexts';
export const useCalendarData = () => {
    const calendarRef = useRef(null);
    const { setActive } = useCalendarContext();
    const [scrollToToday, setScrollToToday] = useState(false);
    const data = useMemo(() => {
        return Array.from({ length: 48 })
            .map((_, index) => (index < 24 ? index * -1 : index - 23))
            .sort((a, b) => a - b)
            .map((curr) => moment().clone().add(curr, 'months').startOf('month').toISOString());
    }, []);
    const initialScrollIndex = useMemo(() => data.findIndex((curr) => moment(curr).isSame(moment(), 'month')), []);
    useEffect(() => {
        if (calendarRef.current && scrollToToday) {
            calendarRef.current.scrollToItem({
                item: moment().startOf('month').toISOString()
            });
            setActive(moment().startOf('day').toISOString());
            setScrollToToday(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollToToday]);
    const setChangedItem = (viewableItems) => {
        var _a;
        const item = (_a = viewableItems.changed[0]) === null || _a === void 0 ? void 0 : _a.item;
        if (!item)
            return;
        if (moment(item).isSame(moment(), 'month'))
            setActive(moment().toISOString());
        else
            setActive(item);
    };
    const onViewableItemsChanged = useCallback((viewableItems) => {
        setChangedItem(viewableItems);
    }, []);
    return {
        calendarRef,
        data,
        initialScrollIndex,
        onViewableItemsChanged
    };
};
//# sourceMappingURL=useCalendarData.js.map